import { Injectable } from '@angular/core';

@Injectable()
export class LoggerService {

    constructor(
    ) { }

    public try(message,
        type: LogType,
        component: number,
        category: LogCategory): void {

        // Don't log anything if we don't have a profile and diagnostic flags (...or maybe log everything?)
        var components: number = +localStorage.getItem(type);
        var categories: number = +localStorage.getItem('logCategory');

        var componentName: string;
        switch (type) {
            case "logCoreComponent":
                componentName = LogCoreComponent[component];
                break; 
            case "logCoreService":
                componentName = LogCoreService[component];
                break; 
            case "logDirective":
                componentName = LogDirective[component];
                break; 
            case "logPage":
                componentName = LogPage[component];
                break; 
            case "logService":
                componentName = LogService[component];
                break; 
            case "logWidget":
                componentName = LogWidget[component];
                break; 
        }

        if (!!components && !!categories
            && ((components & component) == component)
            && ((categories & category) == category)) {
            console.log(`${message} [${type}:${componentName}; ${LogCategory[category]}]` );
        }
    }
}

export enum LogType {
    CoreComponent = "logCoreComponent",
    CoreService = "logCoreService",
    Directive = "logDirective",
    Widget = "logWidget",
    Page = "logPage",
    Service = "logService",
}


export enum LogCoreComponent {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    // Alert = 1 << 1,
    Environment = 1 << 2,
    Header = 1 << 3,
    //Help = 1 << 4,
    Login = 1 << 5,
    ModalError = 1 << 6,
    ModalSave = 1 << 7,
    //NotFound = 1 << 8,
    Ocid = 1 << 9,
    Sidebar = 1 << 10,
    Modal = 1 << 11,
    // Unavailable = 1 << 11,
    // UtilityNavigation = 1 << 12,
    // Don't go above 29! 

    Unused = 1 << 30,   
}

export enum LogCoreService {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    Alert = 1 << 1,
    AuthGuard = 1 << 2,
    Authentication = 1 << 3,
    // CanDeactivateGuard = 1 << 4,
    Cms = 1 << 5,
    //DeactivateGuard = 1 << 6,
    //Logger = 1 << 7,
    PageGuard = 1 << 8,
    Profile = 1 << 9,
    Sidebar = 1 << 10,
    Social = 1 << 11,
    TagManager = 1 << 12,
    TokenInterceptor = 1 << 13,
    Utility = 1 << 14,
    // Don't go above 29! 

    Unused = 1 << 30,
}

export enum LogDirective {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    // HoverReplaceText = 1 << 1,
    WidgetsHost = 1 << 2,
    ComponentsHost = 1 << 3,
    // Don't go above 29! 

    Unused = 1 << 30,
}

export enum LogPage {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    Careers = 1 << 1,           // careers
    CourseCatalog = 1 << 2,     // course-catalog
    Courses = 1 << 3,           // courses
    Dashboard = 1 << 4,         // dashboard
    Facilities = 1 << 5,        // facilities
    People = 1 << 6,            // people
    Profile = 1 << 7,           // profile 
    Resources = 1 << 8,         // resources
    PeopleDownload = 1 << 9,    // people-download
    Social = 1 << 10,           // social
    Search = 1 << 11,           // search
    // Don't go above 29! 

    Unused = 1 << 30,           // notes, instagram, twitter 
}

export enum LogService {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    Announcements = 1 << 1,     // announcements
    Bidding = 1 << 2,           // bidding
    Calendar = 1 << 3,          // calendar
    Canvas = 1 << 4,            // canvas
    Careers = 1 << 5,           // canvas
    // Countdown = 1 << 6,         // countdown
    DegreeAudit = 1 << 7,
    CourseCatalog = 1 << 8,     // course-catalog
    Enrollments = 1 << 9,       // enrollments
    FacilitiesEvent = 1 << 10,   // facilities.event
    FacilitiesIssue = 1 << 11,   // facilities.issue
    FacilitiesParking = 1 << 12, // facilities.parking
    Kudos = 1 << 13,             // kudos
    MySupportRequests = 1 << 14, // my-support-requests
    People = 1 << 15,            // people
    PointsTracking = 1 << 16,    // points-tracking
    TransferCredits = 1 << 17,   //transfer-credits
    Widget = 1 << 18,           // widget
    Search = 1 << 19,           // search
    // Don't go above 29! 

    Unused = 1 << 30,           // twitter 
}

export enum LogWidget {
    None = 0,

    // Commented out components appear in the code but do not implement logging 

    Announcements = 1 << 1,     // announcements
    Bidding = 1 << 2,           // bidding
    Calendar = 1 << 3,          // calendar
    CanvasAssignments = 1 << 4, // canvas-assignments
    CanvasMetrics = 1 << 5,     // canvas-metrics
    Contacts = 1 << 6,          // contacts
    Documents = 1 << 7,         // documents
    DropAdd = 1 << 8,           // drop-add
    Events = 1 << 9,            // events
    FacultyCourses = 1 << 10,   // faculty-courses
    Forms = 1 << 11,            // forms
    JobPostings = 1 << 12,      // job-postings
    Kudos = 1 << 13,            // kudos
    LegacyCup = 1 << 14,        // legacy-cup
    Links = 1 << 15,            // links
    MyCourses = 1 << 16,        // my-courses
    MySupportRequests = 1 << 17,// my-support-requests
    PointsTracking = 1 << 18,   // points-tracking
    TransferCredits = 1 << 19,  // transfer-credits
    Hello = 1 << 20,            // hello
    Agenda = 1 << 21,           // agenda
    //Clubs = 1 << 22,            // clubs
    MyDegree = 1 << 23,         // my-degree
    Files = 1 << 24,            // files hackathon
    MyLinks = 1 << 25,
    // Don't go above 29! 

    Unused = 1 << 30,           // notes, instagram, twitter 
}

// Horizontal slice 
export enum LogCategory {
    None = 0,

    Default = 1 << 1, 
    Constructor = 1 << 2,
    Init = 1 << 3,
    Destroy = 1 << 4,
    SubscriptionData = 1 << 5, 
    // Don't go above 29! 
}
